var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"scroller",class:{ "scroller": true, "fixed": _vm.inView, "bottomAligned": _vm.bottomAligned }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }